module.exports = __webpack_public_path__ + "static/media/main.2d6ddcc5.jpg";